import ApiPermisos from './../../services/apiPermisos'

export default {
  namespaced: true,
  state: {
    errorMsj: '',
    categories: [],
    loadingH: false,
    turnos: [],
    colaboradores: [],
    novedades: [],
    historial: [],
    turno: {}
  },
  getters: {

    getColaboradores:(state)=>{
      return state.colaboradores.filter(row => row.status == 1);
    },

    getTotalNovedades:(state)=>{
      let total = state.novedades.filter(row => row.type == 1)
      return total.length;
    },
    getTotalRotativos:(state)=>{
      let total = state.novedades.filter(row => row.type == 2)
      return total.length;
    },

    getNovedades: (state) =>{
      return state.novedades.filter(row => row.type == 1)
    },

    getRotativos: (state) =>{
      return state.novedades.filter(row => row.type == 2)
    },

    getAllTurnos: (state) =>{
      return state.turnos;
    },

    getTurno: (state) =>{
      return state.turno;
    },

    getAllColaboradores: (state) =>{
      return state.colaboradores;
    },
    getAllNovedades: (state) =>{
      return state.novedades;
    }
  },
  mutations: {
    setTurno: (state, turno) => {
      state.turno = [];
      state.turno = turno;
    },

    setTurnos: (state, turnos) => {
      state.tipshift = [];
      state.tipshift = turnos;
    },
    setColaboradores: (state, colaboradores) => {
      state.colaboradores = [];
      state.colaboradores = colaboradores;
    },
    setHistory: (state, historial) => {
      state.historial = [];
      state.historial = historial;
    },
    setNovedad: (state, novedades) => {
      state.novedades = [];
      state.novedades = novedades;
    },
    setLoading: (state, loadingH) => {
      state.loadingH = loadingH;
    },
    
  },
  actions: {    
     //Trae listado de las personas
    actGetTurnos: async ({
      commit
    }, data) => {
        commit('setLoading', true);
        let response = await ApiPermisos.getReportPropinas(data);
        if (response.error) {
          commit('setLoading', false);
            return response.error;
        }
        else{
          commit('setLoading', false);
          commit('setTurnos', response);
        }
        return response;
    },

    //Traer los colaboradores y las novedades
    actGetColaboradoresNovedades: async ({
      commit
    }, data) => {
        commit('setLoading', true);
        let response = await ApiPermisos.getReportColaboradoresNovedades(data);
        if (response.error) {
            commit('setLoading', false);
            return response.error;
        }
        else{
          commit('setLoading', false);
          commit('setColaboradores', response.data.colaboradores);
          commit('setNovedad', response.data.novedades);
          commit('setTurno', response.data.turno);
        }
        return response;
    },

    actGetHistorial: async ({
      commit
    }, data) => {
        commit('setLoading', true);
        let response = await ApiPermisos.getReportHistory(data);
        //console.log('historial',response);
        if (response.error) {
            commit('setLoading', false);
            return response.error;
        }
        else{
          commit('setLoading', false);
          commit('setHistory', response.data);
        }
        return response;
    },

    // Setear la tabla de novedades
    actSetTableNovedades: async ({
      commit
    }, data) => {
          commit('setLoading', true);
          commit('setLoading', false);
          commit('setNovedad', data);
          return true;          
    },
    
  },
}